import { render, staticRenderFns } from "./OptionSelector.vue?vue&type=template&id=3b9f2f21&scoped=true"
import script from "./OptionSelector.vue?vue&type=script&lang=js"
export * from "./OptionSelector.vue?vue&type=script&lang=js"
import style0 from "./OptionSelector.vue?vue&type=style&index=0&id=3b9f2f21&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b9f2f21",
  null
  
)

export default component.exports